import { useSearchParams, URLSearchParamsInit } from "react-router-dom";
import { cleanObject } from "../Components/utils/cleanobject-utils";

export const useSetUrlSearchParam = () => {
  const [searchParams, setSearchParam] = useSearchParams();
  return (params: { [key in string]: unknown }) => {
    const o = cleanObject({
      ...Object.fromEntries(searchParams),
      ...params,
    }) as URLSearchParamsInit;
    return setSearchParam(o);
  };
};
